// src/layouts/AuthLayout.jsx — Full-screen centered wrapper for auth screens
import React from 'react';
import '../styles/common.css';

export default function AuthLayout({ children }) {
  return (
    <div className="overlay-full">
      {children}
    </div>
  );
}
